const DeptTypes = {
  GET_DEPARTMENT_LIST_REQUEST: 'GET_DEPARTMENT_LIST_REQUEST',
  GET_DEPARTMENT_LIST_SUCCESS: 'GET_DEPARTMENT_LIST_SUCCESS',
  GET_DEPARTMENT_LIST_ERROR: 'GET_DEPARTMENT_LIST_ERROR',

  ADD_DEPARTMENT_REQUEST: 'ADD_DEPARTMENT_REQUEST',
  ADD_DEPARTMENT_SUCCESS: 'ADD_DEPARTMENT_SUCCESS',
  ADD_DEPARTMENT_ERROR: 'ADD_DEPARTMENT_ERROR',

  GET_DEPARTMENT_ITEM_REQUEST: 'GET_DEPARTMENT_ITEM_REQUEST',
  GET_DEPARTMENT_ITEM_SUCCESS: 'GET_DEPARTMENT_ITEM_SUCCESS',
  GET_DEPARTMENT_ITEM_ERROR: 'GET_DEPARTMENT_ITEM_ERROR',

  UPDATE_DEPARTMENT_REQUEST: 'UPDATE_DEPARTMENT_REQUEST',
  UPDATE_DEPARTMENT_SUCCESS: 'UPDATE_DEPARTMENT_SUCCESS',
  UPDATE_DEPARTMENT_ERROR: 'UPDATE_DEPARTMENT_ERROR',

  DELETE_DEPARTMENT_REQUEST: 'DELETE_DEPARTMENT_REQUEST',
  DELETE_DEPARTMENT_SUCCESS: 'DELETE_DEPARTMENT_SUCCESS',
  DELETE_DEPARTMENT_ERROR: 'DELETE_DEPARTMENT_ERROR',

  GET_DEPARTMENT_ACTIVE_REQUEST: 'GET_DEPARTMENT_ACTIVE_REQUEST',
  GET_DEPARTMENT_ACTIVE_SUCCESS: 'GET_DEPARTMENT_ACTIVE_SUCCESS',
  GET_DEPARTMENT_ACTIVE_ERROR: 'GET_DEPARTMENT_ACTIVE_ERROR',

  UPDATE_QUERY_PARAMS: 'UPDATE_QUERY_PARAMS'
};
export default DeptTypes;
